import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { ApptokenService } from '../service/apptoken.service';

export const authenGuard: CanActivateFn = (route, state) => {
  const appTokenSV = inject(ApptokenService)
  const router = inject(Router)

  const keyToken = localStorage.getItem('token')
  if (!keyToken) {
    return router.createUrlTree(['/login'])
  }

  let role: any
  try {
    role = JSON.parse(keyToken)
  } catch {
    localStorage.removeItem('token')
    return router.createUrlTree(['/login'])
  }

  const isExpired = checkTokenExpired(role)

  if (isExpired) {
    localStorage.removeItem('token')
    return router.createUrlTree(['/login'])
  }

  if (!appTokenSV.payload) {
    appTokenSV.payload = role
  }

  return true
};


export const authenGuardChild: CanActivateChildFn = (
  routes,
  state,
) => authenGuard(routes,state)

const checkTokenExpired = (role: any): boolean => {
  const expireAtMs = getExpireAt(role)
  if (expireAtMs === null) {
    return false
  }
  return Date.now() >= expireAtMs
}

const getExpireAt = (role: any): number | null => {
  const directExpire = normalizeEpoch(
    role?.token?.expire_at ??
    role?.access_token?.expire_at ??
    role?.expire_at
  )

  if (directExpire !== null) {
    return directExpire
  }

  const isoExpire = parseIsoDate(
    role?.expires ??
    role?.token?.expires ??
    role?.access_token?.expires
  )

  if (isoExpire !== null) {
    return isoExpire
  }

  const rawToken = extractToken(role)
  if (!rawToken) {
    return null
  }

  const jwtExp = extractJwtExp(rawToken)
  return jwtExp !== null ? jwtExp * 1000 : null
}

const extractToken = (role: any): string | null => {
  const candidates = [
    role?.token,
    role?.token?.token,
    role?.access_token,
    role?.access_token?.token
  ]

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.length > 0) {
      return candidate
    }
  }

  if (typeof role === 'string' && role.length > 0) {
    return role
  }

  return null
}

const extractJwtExp = (token: string): number | null => {
  const parts = token.split('.')
  if (parts.length !== 3) {
    return null
  }

  try {
    const payloadSegment = decodeBase64Url(parts[1])
    const payload = JSON.parse(payloadSegment)
    return typeof payload?.exp === 'number' ? payload.exp : null
  } catch {
    return null
  }
}

const normalizeEpoch = (value: unknown): number | null => {
  if (value === null || value === undefined) {
    return null
  }

  const numeric = Number(value)
  if (!Number.isFinite(numeric) || numeric <= 0) {
    return null
  }

  return numeric > 1e12 ? numeric : numeric * 1000
}

const decodeBase64Url = (value: string): string => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(value.length / 4) * 4, '=')
  return atob(base64)
}

const parseIsoDate = (value: unknown): number | null => {
  if (typeof value !== 'string' || value.trim().length === 0) {
    return null
  }

  const parsed = Date.parse(value)
  return Number.isNaN(parsed) ? null : parsed
}
